import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=80623358&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "../../theme/side-menu.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./SideMenu.vue?vue&type=style&index=1&id=80623358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80623358",
  null
  
)

export default component.exports